/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - Верстка выпадающего меню</h2>
    <p className={styles.description}>
      Выпадающее меню - это наиболее популярный тип меню на веб-страницах. Рассмотрим этапы создания такого меню.
      Предложенные имена классов приведены для ясности изложения.{' '}
    </p>
    <ol className={styles.list}>
      <li className={styles.list__item}>
        Необходимо создать обычное меню, присвоив <code className={styles.code}>class="menu"</code> блоку и{' '}
        <code className={styles.code}>class="menu-item"</code> элементам меню.{' '}
      </li>
      <li className={styles.list__item}>
        Внутри <code className={styles.code}>menu-item</code> разместите новое меню, с{' '}
        <code className={styles.code}>class="submenu"</code> и элементами{' '}
        <code className={styles.code}>class="submenu-item"</code>.{' '}
      </li>
      <li className={styles.list__item}>
        Скрываем вложенное меню <code className={styles.code}>{`.submenu { display: none; }`}</code>
      </li>
      <li className={styles.list__item}>
        Задаем правило появления вложенного меню при наведении курсора{' '}
        <code className={styles.code}>{`.menu-item:hover > .submenu { display: block; }`}</code>
      </li>
      <li className={styles.list__item}>
        С помощью <code className={styles.code}>position: absolute</code> размещаем{' '}
        <code className={styles.code}>submenu</code> относительно <code className={styles.code}>li</code> так, чтобы
        была возможность перейти к пунктам <code className={styles.code}>submenu</code>.
      </li>
    </ol>
    <p className={styles.description}>
      Т.е. ключевым является правило появления вложенного меню. Это правило работает так: при наведении на элемент меню,
      содержащий подменю, сработает псевдокласс <code className={styles.code}>hover</code> и прямой потомок (на это
      указывает знак > ) станет видимым.{' '}
    </p>
    <p className={styles.description}>
      Также крайне важен последний этап. Например, при наличии <code className={styles.code}>1px</code> границы (border)
      у <code className={styles.code}>menu</code> может происходить отмена действия{' '}
      <code className={styles.code}>hover</code>. Дело в том, что на сам блок <code className={styles.code}>menu</code>{' '}
      эффект <code className={styles.code}>hover</code> не распространяется. Его действие связано только с{' '}
      <code className={styles.code}>menu-item</code> и если браузер зафиксирует курсор не над{' '}
      <code className={styles.code}>menu-item</code>, то вернется состояние по умолчанию и подменю исчезнет. Такую
      ошибку сложно обнаружить, т.к. браузер не отслеживает каждый пройденный курсором пиксель, и ошибка проявляется
      время от времени.
    </p>
    <iframe
      height="300"
      scrolling="no"
      title="relative_shift"
      src="https://codepen.io/GoIT-fe/embed/OjbBXq?default-tab=html%2Cresult"
      frameBorder="no"
      loading="lazy"
      allowTransparency="true"
      allowFullScreen="true"
    />
  </section>
))
